import { Card, CardBody, CardHeader, Col, Collapse, Row } from 'reactstrap';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CollapsibleChevron from '../CollapsibleChevron';
import Icon from '../common/Icon';
import StatusBanner, { StatusColor } from './StatusBanner';
import AlertBadge from './AlertBadge';
import useAllAlerts from './hooks/useAllAlerts';
import { useMemberStaleAwareData } from '../Context/useMemberStaleAwareData';


export type NotificationBannerItem = {
    status?: StatusColor;
    icon?: React.ReactNode;
    text: string | React.ReactNode;
    buttonText?: string;
    buttonHref?: string;
    onButtonClick?: () => void;
    highlight: boolean;
    highlightOrder?: number;
};


const NotificationBanner: React.FC = () => {
  const location = useLocation();
  const { lastLoaded } = useMemberStaleAwareData();  
  const [ expanded, setExpanded ] = useState(false);
  const { alerts, refreshAll } = useAllAlerts()

  const toggleOpen = () => {
      setExpanded((prev) => !prev);
  }

  useEffect(() => {
    setExpanded(false);
    refreshAll();
  },[location, lastLoaded, refreshAll])

  useEffect(() => {
    refreshAll();
  },[expanded, refreshAll])


  const CardHeaderTitle = ({ expanded, totalNotifications }) => {
    const plural = totalNotifications !== 1;

    const title = expanded
      ? plural
        ? 'Notifications'
        : 'Notification'
      : plural
        ? 'Notifications - click to expand'
        : 'Notification - click to expand';

    return (
      <div className="d-flex align-items-center gap-2" onClick={toggleOpen}>        
        {alerts.some(x => x.status === 'red') && (
          <Icon name="warning" color="red" />
        )}
        <span onClick={toggleOpen}>{title}</span>
        <AlertBadge count={totalNotifications}/> 
      </div>
    );
  };

  const renderStatusBanner = (item: NotificationBannerItem, key: number) => {
    return (
    <StatusBanner
      key={key}
      status={item.status}
      icon={item.icon}
      text={item.text}
      buttonText={item.buttonText}
      buttonHref={item.buttonHref}
      onButtonClick={item.onButtonClick}
    />)
  } 
const sortedAlerts = [...alerts].sort((a, b) => {
  if (a.highlight === b.highlight) {
    return (a.highlightOrder ?? 0) - (b.highlightOrder ?? 0);
  }

  return a.highlight ? -1 : 1;
});
  const showAlerts = alerts.length > 0;
  
  if (!showAlerts) { return null; }
  return (
    <Card className="w-100">
      <CardHeader onClick={toggleOpen} style={{ fontWeight: 800 }} className="text-green text-uppercase font-larger collapsible-card-header">
          <Row onClick={toggleOpen}>
              <Col>
                <div className="d-flex justify-content-between" onClick={toggleOpen} >
                  <CardHeaderTitle 
                    expanded={expanded}
                    totalNotifications={alerts.length}
                  />
                </div>
              </Col>
              <Col xs='auto' className='text-white p-0 m-0 border-0 d-inline'>
                  <div>                                         
                    <CollapsibleChevron size="0" isOpen={expanded} textColour="green" />
                  </div>
              </Col>
          </Row>
      </CardHeader>
      <Collapse isOpen={expanded}>       
        <CardBody style={{ paddingTop: "0px" }}>        
          <Row>
            <Col>

              {sortedAlerts.map((a, k) => renderStatusBanner(a, k))}
            </Col>
          </Row>
        </CardBody>   
      </Collapse>
    </Card>
  )
};

export default NotificationBanner;
